import { EmployeeNameRequest, EmployeesDeptWiseResponseModel, EmployeeUpdateReq } from '@gtpl/shared-models/gtpl';
import { AllEmployeesResponseModel, EmployeeResponseModel, EmployeeRequest, CommonResponse, EmployeeDepartmentRequest, ContractorIdReq } from '@gtpl/shared-models/masters';
import { InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError, errorHandler, ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiBody, ApiTags } from '@nestjs/swagger';
import { request } from 'http';
import { Any } from 'typeorm';
import { DeptRequest } from './dto/dept-request';
import { EmpTeamRequest } from './dto/emp-team.request';
import { EmployeeByUnitRequest } from './dto/employee-by-unit-request';
import { EmployeeCodeRequest } from './dto/employee-code.request';
import { EmployeeDeptRequest } from './dto/employee-dept.request';
import { EmployeeDesignationRequest } from './dto/employee-designation';
import { EmployeeDetailsDTO } from './dto/employee-details.dto';
import { EmployeeRoleRequest } from './dto/employee-role.request';
import { EmployeeDetails } from './employee-details.entity';
import { EmployeeDetailsService } from './employee-details.service';
import { PayrollRequestEmp } from '@gtpl/shared-models/hrms';
@ApiTags('employee-details')
@Controller('employee-details')
export class EmployeeDetailsController {
  constructor(private employeeDetailsService: EmployeeDetailsService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }
  @Post('/createEmployee')
  async createEmployee(@Body() employeeDetailsDTO: EmployeeDetailsDTO, isUpdate: boolean = false,
  ): Promise<EmployeeResponseModel> {
    console.log("employeeDetailsDTO" + employeeDetailsDTO)
    try {
      return await this.employeeDetailsService.createEmployee(employeeDetailsDTO, false);
    } catch (error) {
      // return errorHandler(EmployeeResponseModel,error);
      return this.applicationExceptionHandler.returnException(EmployeeResponseModel, error);
    }
  }
  @Post('/updateEmployee')
  async updateEmployee(@Body() employeeDetailsDTO: EmployeeDetailsDTO): Promise<EmployeeResponseModel> {
    try {
      console.log('update variant');
      return await this.employeeDetailsService.createEmployee(employeeDetailsDTO, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(EmployeeResponseModel, error);
    }
  }
  @Post('/getAllEmployees')
  // @UseGuards(AuthGuard('jwt'))
  async getAllEmployees(): Promise<CommonResponse> {
    try {
      return await this.employeeDetailsService.getAllEmployee();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getEmployeeForPayroll')
  // @UseGuards(AuthGuard('jwt'))
  async getEmployeeForPayroll(@Body() req:PayrollRequestEmp): Promise<CommonResponse> {
    console.log(req,'connnnnnnnnnnnnnnnnnn')
    try {
      return await this.employeeDetailsService.getEmployeeForPayroll(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getAllActiveEmployees')
  async getAllActiveEmployees(@Req() request: Request): Promise<AllEmployeesResponseModel> {
    try {
      return await this.employeeDetailsService.getAllActiveEmployees();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllEmployeesResponseModel, error)
    }
  }
  @Post('/getActiveEmployeesById')
  async getActiveEmployeesById(@Body() employeeRequest: EmployeeRequest, @Req() request: Request): Promise<EmployeeResponseModel> {
    try {
      return await this.employeeDetailsService.getActiveEmployeesById(employeeRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(EmployeeResponseModel, error)
    }
  }

  @Post('/getActiveEmployeesByEmpCode')
  async getActiveEmployeesByEmpCode(@Body() empCode: EmployeeCodeRequest): Promise<EmployeeResponseModel> {
    try {
      return await this.employeeDetailsService.getActiveEmployeesByEmpCode(empCode);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(EmployeeResponseModel, error)
    }
  }

  @Post('/getEmployeeByEmpCode')
  async getEmployeeByEmpCode(@Body() empCode: EmployeeCodeRequest): Promise<EmployeeResponseModel> {
    try {
      return await this.employeeDetailsService.getEmployeeByEmpCode(empCode);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(EmployeeResponseModel, error)
    }
  }

  @Post('/getActiveEmployeesByRole')
  async getActiveEmployeesByRole(@Body() employeeRoleRequest: EmployeeRoleRequest): Promise<AllEmployeesResponseModel> {
    try {
      return await this.employeeDetailsService.getActiveEmployeesByRole(employeeRoleRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllEmployeesResponseModel, error)
    }
  }

  @Post('/getActiveEmployeesByDept')
  async getActiveEmployeesByDept(@Body() employeeDeptRequest: EmployeeDeptRequest): Promise<AllEmployeesResponseModel> {
    try {
      return await this.employeeDetailsService.getActiveEmployeesByDept(employeeDeptRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllEmployeesResponseModel, error)
    }
  }

  @Post('/getActiveEmployeesByDeptId')
  async getActiveEmployeesByDeptId(@Body() deptId: number): Promise<AllEmployeesResponseModel> {
    try {
      return await this.employeeDetailsService.getActiveEmployeesByDeptId(deptId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllEmployeesResponseModel, error)
    }
  }

  @Post('/getAllActiveEmployeesForLeaves')
  async getAllActiveEmployeesForLeaves(@Req() request: Request): Promise<AllEmployeesResponseModel> {
    try {
      return await this.employeeDetailsService.getAllActiveEmployeesForLeaves();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllEmployeesResponseModel, error)
    }
  }

  @Post('/updateDesignationForDesignationAction')
  async updateDesignationForDesignationAction(@Body() request: EmployeeDesignationRequest): Promise<CommonResponse> {
    try {
      return await this.employeeDetailsService.updateDesignationForDesignationAction(request);
    } catch (error) {
      // return errorHandler(EmployeeResponseModel, error);
      return this.applicationExceptionHandler.returnException(EmployeeResponseModel, error);
    }
  }

  @Post('/updateDepartmentForDesignationAction')
  async updateDepartmentForDesignationAction(@Body() request: EmployeeDepartmentRequest): Promise<CommonResponse> {
    try {
      return await this.employeeDetailsService.updateDepartmentForDesignationAction(request);
    } catch (error) {
      // return errorHandler(EmployeeResponseModel, error);
      return this.applicationExceptionHandler.returnException(EmployeeResponseModel, error);
    }
  }

  @Post('/getActiveEmployeeByEmpCode')
  async getActiveEmployeeByEmpCode(@Body() empCode: string): Promise<EmployeeResponseModel> {
    try {
      return await this.employeeDetailsService.getActiveEmployeeByEmpCode(empCode);
    } catch (error) {
      return error;
    }
  }

  @Post('/getActiveEmpDeptWiseCount')
  async getActiveEmpDeptWiseCount(@Body() deptReq: DeptRequest): Promise<EmployeesDeptWiseResponseModel> {
    try {
      return await this.employeeDetailsService.getActiveEmpDeptWiseCount(deptReq);
    } catch (error) {
      return error;
    }
  }

  @Post('/getEmployeesByUnitId')
  async getMachineName(@Body() request: EmployeeByUnitRequest): Promise<AllEmployeesResponseModel> {
    try {
      return await this.employeeDetailsService.getEmployeesByUnitId(request);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllEmployeesResponseModel, error)
    }
  }

  @Post('/getEmployeeUnitData')
  async getEmployeeUnitData(): Promise<CommonResponse> {
    try {
      return await this.employeeDetailsService.getEmployeeUnitData();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error)
    }
  }

  @Post('/getAllInactiveEmployees')
  async getAllInactiveEmployees(@Req() request: Request): Promise<AllEmployeesResponseModel> {
    try {
      return await this.employeeDetailsService.getAllInactiveEmployees();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllEmployeesResponseModel, error)
    }
  }
  @Post('/getActiveEmployeesByName')
  async getActiveEmployeesByName(@Body() employeeRequest: EmployeeNameRequest, @Req() request: Request): Promise<EmployeeResponseModel> {
    try {
      return await this.employeeDetailsService.getActiveEmployeesByName(employeeRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(EmployeeResponseModel, error)
    }
  }

  @Post('/getEmployeeByContractor')
  async getEmployeeByContractor(@Body() req: ContractorIdReq): Promise<CommonResponse> {
    try {
      return await this.employeeDetailsService.getEmployeeByContractor(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error)
    }
  }

  @Post('/getEmployeeInfoByEmployeeId')
  async getEmployeeInfoByEmployeeId(@Body() req: EmployeeRequest): Promise<CommonResponse> {
    try {
      return await this.employeeDetailsService.getEmployeeInfoByEmployeeId(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error)
    }
  }

  @Post('/getAllContractorAgainstEmployees')
  async getAllContractorAgainstEmployees(): Promise<CommonResponse> {
    try {
      return await this.employeeDetailsService.getAllContractorAgainstEmployees();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error)
    }
  }

  @Post('/getDepartmentByTypeOrCategory')
  async getDepartmentByTypeOrCategory(@Body() req: PayrollRequestEmp): Promise<CommonResponse> {
    try {
      return await this.employeeDetailsService.getDepartmentByTypeOrCategory(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error)
    }
  }
  @Post('/updateAvalibility')
  async updateAvalibility(@Body() req: EmployeeUpdateReq): Promise<CommonResponse> {
    try {
      return await this.employeeDetailsService.updateAvalibility(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error)
    }
  }
  @Post('/getAllActiveDrivers')
  async getAllActiveDrivers(): Promise<CommonResponse> {
    try {
      return await this.employeeDetailsService.getAllActiveDrivers();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error)
    }
  }
  @Post('/getAllActiveAuthorisedEmployees')
  async getAllActiveAuthorisedEmployees(@Req() request: Request): Promise<AllEmployeesResponseModel> {
    try {
      return await this.employeeDetailsService.getAllActiveAuthorisedEmployees();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllEmployeesResponseModel, error)
    }
  }
}
